var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgButtonBackArrow(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 15,
    viewBox: "0 0 10 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.2308 0.769014C8.59597 1.13437 8.59597 1.69513 8.2308 2.06048L2.57673 7.71734C2.16375 8.13052 1.4535 8.13052 1.04053 7.71734C0.675355 7.35198 0.675356 6.79122 1.04053 6.42587L6.6946 0.769014C7.10757 0.355836 7.81782 0.355836 8.2308 0.769014Z",
    fill: "#B9BABA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.03073 6.46971C1.4437 6.05653 2.15395 6.05653 2.56693 6.46971L8.22099 12.1266C8.58617 12.4919 8.58617 13.0527 8.221 13.418C7.80802 13.8312 7.09777 13.8312 6.6848 13.418L1.03073 7.76118C0.665555 7.39583 0.665555 6.83506 1.03073 6.46971Z",
    fill: "#B9BABA"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgButtonBackArrow);
export default __webpack_public_path__ + "static/media/button_back_arrow.55542c7c.svg";
export { ForwardRef as ReactComponent };